import { getApi } from "../../services/httpService";

export function getPromotion() {
  return getApi().get('home/promotion');
}